import type { ReactNode } from "react";

interface SectionTitleProps {
  /** Petite étiquette au-dessus du titre (« Modules », « Tarifs »…). */
  eyebrow?: string;
  title: ReactNode;
  intro?: ReactNode;
  align?: "left" | "center";
  /** Sur fond sombre. */
  invert?: boolean;
  className?: string;
}

/** Titre de section du site public : étiquette pastille, titre en Plus Jakarta Sans, phrase d'introduction. */
export default function SectionTitle({ eyebrow, title, intro, align = "left", invert, className = "" }: SectionTitleProps) {
  const centered = align === "center";
  return (
    <div className={`${centered ? "mx-auto text-center" : ""} max-w-2xl ${className}`}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wider ${
            invert ? "border-white/25 text-white/85" : "border-primary-200 bg-primary-50 text-primary-800"
          }`}
        >
          <span className={`h-1.5 w-1.5 rounded-full ${invert ? "bg-primary-300" : "bg-primary-500"}`} aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2
        className={`mt-4 text-3xl font-bold font-heading leading-tight tracking-tight md:text-[2.5rem] ${
          invert ? "text-white" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {intro && (
        <p className={`mt-4 text-base leading-relaxed md:text-lg ${invert ? "text-white/80" : "text-foreground-600"}`}>{intro}</p>
      )}
    </div>
  );
}
